import TrustBar from '../../components/feature/TrustBar';
import PageHero from '../../components/feature/PageHero';
import ServicesDetailed from './components/ServicesDetailed';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import Process from '../../components/feature/Process';
import WhyChoose from '../../components/feature/WhyChoose';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import type { AIQAItem } from '../../components/feature/AIAnswerBlock';
import type { FAQItem } from '../../components/feature/FAQ';

const aiItems: AIQAItem[] = [
  {
    question: 'What is residential architecture design?',
    answer:
      'Residential architecture design is the professional creation of homes — encompassing site analysis, spatial layout, material selection, and construction documentation. Talo Architect provides comprehensive design services tailored to each client\'s specific lifestyle, property, and vision across NYC and Westchester.',
  },
  {
    question: 'Who are these architectural services for?',
    answer:
      'Our services serve homeowners seeking thoughtfully designed custom homes, meaningful renovations, or carefully considered additions. Whether building from scratch or transforming an existing home, we collaborate closely to realize your vision with precision and architectural excellence.',
  },
  {
    question: 'What does a client receive at the end of the process?',
    answer:
      'Clients receive a complete architectural design package — including concept drawings, design development documents, and construction-ready permit drawings — along with expert guidance throughout all design and construction phases.',
  },
];

const whyItems = [
  'Complete design documentation at every project phase',
  'Material and finish selection guidance and coordination',
  'Code-compliant, permit-ready architectural drawings',
  'Budget-conscious design without compromising quality',
  'Expert coordination with contractors and engineers',
  'Over 20 years designing residential architecture in NYC and Westchester',
];

const faqItems: FAQItem[] = [
  {
    question: 'What is included in an architectural design service?',
    answer:
      'A full architectural design service includes site analysis, schematic design, design development, construction documentation, and permit submission coordination. The scope is tailored to each project\'s specific needs, size, and complexity for residential homes across Westchester and New York City.',
  },
  {
    question: 'How long does a residential design project take?',
    answer:
      'Design timelines vary by project scope. A renovation or addition typically takes 2–4 months through design completion. A full custom home design may require 4–8 months depending on complexity, revision rounds, and municipal approval requirements specific to your location.',
  },
  {
    question: 'Is an architect necessary for a home renovation?',
    answer:
      'For significant renovations, additions, or new construction, an architect ensures proper structural planning, code compliance, and design quality. Most municipalities in Westchester County and New York City require architectural drawings for permit applications on projects beyond minor cosmetic changes.',
  },
  {
    question: 'Can you work with my builder or general contractor?',
    answer:
      'Yes. We regularly collaborate with general contractors and builders of all scales throughout the region. We provide complete construction documentation packages that contractors can bid from and remain available for design clarifications throughout the entire build process.',
  },
];

export default function ServicesPage() {
  return (
    <>
      <PageHero
        eyebrow="Talo Architect · Residential Services"
        title="Custom Residential Architecture"
        subtitle="Designed with clarity, purpose, and precision for how you live."
        primaryCta="Start Your Project"
        secondaryCta="View Services"
        secondaryHref="#services"
        bgImage="https://public.readdy.ai/ai/img_res/73f29983cfb59bd439657197dca8db21.jpg"
      />
      <TrustBar />
      <ServicesDetailed />
      <AIAnswerBlock items={aiItems} title="About These Services" />
      <Process ctaText="Request Consultation" />
      <WhyChoose items={whyItems} />
      <ServiceAreas />
      <Testimonials />
      <FAQ items={faqItems} title="Service Questions Answered" />
      <FinalCTA
        headline="Ready to Start Your Architectural Project?"
        subline="Tell us about your home, your vision, and your timeline. We'll take it from there."
        primaryCta="Request Consultation"
        secondaryCta="Call (914) 645-2940"
      />
    </>
  );
}
